"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkUtilsDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.LinkUtilsDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-link-utils');
//# sourceMappingURL=index.js.map